/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

  document.addEventListener('DOMContentLoaded', function () {
    
  let customCollection = document.querySelectorAll('.custom-collection-list');

  if (customCollection) {
    customCollection.forEach(element => {
      let navigationNext = element.querySelector('.navigation-slider .flickity-button.next');
      let navigationPrev = element.querySelector('.navigation-slider .flickity-button.previous');

      if (navigationNext) {
        navigationNext.addEventListener('click', function () {
          let sliderActive = element.querySelector('.collection-list-swiper.tab-active');
          if (sliderActive) {
            let nextButton = sliderActive.querySelector('.swiper-button-next');
            // console.log('next:', nextButton)
            if (nextButton) nextButton.click();
          }
        });
      }

      if (navigationPrev) {
        navigationPrev.addEventListener('click', function () {
          let sliderActive = element.querySelector('.collection-list-swiper.tab-active');
          if (sliderActive) {
            let previousButton = sliderActive.querySelector('.swiper-button-prev');
            // console.log('prev:', previousButton)
            if (previousButton) previousButton.click();
          }
        });
      }

      let buttonTabs = element.querySelectorAll('.button-tab');

      buttonTabs.forEach(button => {
        button.addEventListener('click', function () {
          let connectedSlider = button.getAttribute('data-tab');

          if (!button.classList.contains('tab-active')) {
        
            buttonTabs.forEach(el => el.classList.remove('tab-active'));
            button.classList.add('tab-active');

            let allElementSlider = element.querySelectorAll('.collection-list-swiper');
            allElementSlider.forEach(slider => {
              if (slider.getAttribute('data-tab') === connectedSlider) {
                slider.classList.add('tab-active');
              } else {
                slider.classList.remove('tab-active');
              }
            });
          }
        });
      });

    });
  }
  let blogPosts = document.querySelectorAll('.section-blog-post');
  blogPosts.forEach(blog => {
    let customButtonNext = blog.querySelector('.navigation-slider .flickity-button.next');
  
    let customButtonPrev = blog.querySelector('.navigation-slider .flickity-button.previous');
    
    let actualNext = blog.querySelector('.flickity-enabled .flickity-button.next');
    let actualPrev = blog.querySelector('.flickity-enabled .flickity-button.previous');
    if(actualNext){
  
      customButtonNext.addEventListener('click', function(){
        actualNext.click();
      })
    }
    if(actualPrev){
     
      customButtonPrev.addEventListener('click', function(){
        actualPrev.click();
      })
    }
  });
});
let navBarItem = document.querySelectorAll('.nav-bar__item');
navBarItem.forEach(item => {
  let megaMenuContent = item.querySelector('.mega-menu ');
  if(megaMenuContent){
    let megaMenuLinks = megaMenuContent.querySelectorAll('.mega-menu__column');
    let megaMenuSubLinks = megaMenuContent.querySelectorAll('.megamenu-custom-menulinks');
    
    megaMenuLinks.forEach(menuLink => {
      let target = menuLink.getAttribute('data-url');
      menuLink.addEventListener('mouseover', function(){
        megaMenuSubLinks.forEach(element => {
          let subLink = element.getAttribute('data-links');
          if(target == subLink){
            element.classList.add('active');
          }else{
            element.classList.remove('active');
          }
        });
      })
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector("header"); 

  window.addEventListener("scroll", function () {
    if (window.scrollY > 0) {
      header.classList.add("active");
    } else {
      header.classList.remove("active");
    }
  });
});
